import { Spin } from 'antd';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';

const GlobalLoader = ({ activity }) => {
  useEffect(() => {
    document.body.style.overflowY = activity ? 'hidden' : 'auto';
  }, [activity]);

  if (activity)
    return (
      <div
        style={{
          position: 'fixed',
          width: '100vw',
          height: '100vh',
          top: 0,
          left: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 999,
          backgroundColor: 'rgba(255, 255, 255, 0.2)'
        }}
      >
        <div
          style={{
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
            boxShadow: '0 0 20px 4px rgba(0, 0, 0, 0.2)'
          }}
        >
          <Spin indicator={<LoadingOutlined spin />} size='large' />
        </div>
      </div>
    );
};

const mapStateToProps = (state) => ({
  activity: state.app.activity
});

export default connect(mapStateToProps)(GlobalLoader);
